/**
 * Zuora metrics and error tracking constants
 * Used for monitoring payment flow and error reporting
 */

const zuoraMetricConstants = {
  productName: {
    rateConnect: 'Rate Connect',
    plus: 'Business Studio+',
    settings: 'Settings - Edit Payment Method',
  },
  metricErrorCodes: {
    hppLoadError: '110001',
    paymentError: '110002',
    configurationError: '110003',
    clientSideValidationError: '110004',
    emptyOrderIdError: '110005',
    billingInformation: '110006',
  },
  metricScopes: {
    zuora: 'zuora',
    order: 'order',
  },
  metricTypes: {
    error: 'ERROR',
    metric: 'METRIC',
  },
} as const

export default zuoraMetricConstants

/** Union type of product names */
export type ProductNameKey = keyof typeof zuoraMetricConstants.productName

/** Union type of error codes */
export type MetricErrorCode = keyof typeof zuoraMetricConstants.metricErrorCodes

/** Union type of error code values */
export type MetricErrorCodeValue = typeof zuoraMetricConstants.metricErrorCodes[MetricErrorCode]

/** Union type of metric scopes */
export type MetricScope = typeof zuoraMetricConstants.metricScopes[keyof typeof zuoraMetricConstants.metricScopes]

/** Union type of metric types */
export type MetricType = typeof zuoraMetricConstants.metricTypes[keyof typeof zuoraMetricConstants.metricTypes]